export default __webpack_public_path__ + "9bbf2ed81bc0dd6d9880293d8c138b99.png";